import React from 'react';
import {View} from 'react-native';
import {isNil} from 'lodash';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {DownlineProfile} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './MiscMetrics.style';
interface MiscMetricsProps {
  tt: (key: string, fallback: string) => string;
  newFrontlineClientsCount: number;
  newGen0ClientsCount: number;
  newFrontlineCoachesCount: number;
  newGen0CoachesCount: number;
  orderingEntitiesCount: number;
  qualifyingPoints: number;
  frontlineReactivatedClientsCount: number;
  gen0ReactivatedClientsCount: number;
}

export const MiscMetrics: React.FC<MiscMetricsProps> = ({
  tt,
  newFrontlineClientsCount = 0,
  newGen0ClientsCount = 0,
  newFrontlineCoachesCount = 0,
  newGen0CoachesCount = 0,
  orderingEntitiesCount = 0,
  qualifyingPoints = 0,
  frontlineReactivatedClientsCount = 0,
  gen0ReactivatedClientsCount = 0,
}) => (
  <ProfileSection
    analyticsTitle="Metrics"
    style={{base: styles.base}}
    title={tt('heading', 'Metrics')}>
    <View style={styles.listItem}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.newFrontlineClients', 'New Frontline Clients')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.newFrontlineClients}
            variant="button">
            {newFrontlineClientsCount}
          </Text>
        }
        readonly={true}
      />
    </View>
    {!isNil(frontlineReactivatedClientsCount) && (
      <View style={[styles.listItem, styles.listItemWithBorder]}>
        <ListItem
          label={
            <Text allowFontScaling maxFontSizeMultiplier={2}>
              {tt(
                'count.frontlineReactivatedClients',
                'Frontline Reactivated Clients',
              )}
            </Text>
          }
          suffix={
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              testID={DownlineProfile.frontlineReactivatedClients}
              variant="button">
              {frontlineReactivatedClientsCount}
            </Text>
          }
          readonly={true}
        />
      </View>
    )}
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.newGen0Clients', 'New Generation 0 Clients')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.newGen0Clients}
            variant="button">
            {newGen0ClientsCount}
          </Text>
        }
        readonly={true}
      />
    </View>
    {!isNil(gen0ReactivatedClientsCount) && (
      <View style={[styles.listItem, styles.listItemWithBorder]}>
        <ListItem
          label={
            <Text allowFontScaling maxFontSizeMultiplier={2}>
              {tt(
                'count.gen0ReactivatedClients',
                'Generation 0 Reactivated Clients',
              )}
            </Text>
          }
          suffix={
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              testID={DownlineProfile.gen0ReactivatedClients}
              variant="button">
              {gen0ReactivatedClientsCount}
            </Text>
          }
          readonly={true}
        />
      </View>
    )}
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.newFrontlineCoaches', 'New Frontline Coaches')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.newFrontlineCoaches}
            variant="button">
            {newFrontlineCoachesCount}
          </Text>
        }
        readonly={true}
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.newGen0Coaches', 'New Generation 0 Coaches')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.newGen0Coaches}
            variant="button">
            {newGen0CoachesCount}
          </Text>
        }
        readonly={true}
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.orderingEntities', 'Ordering Entities')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.orderingEntities}
            variant="button">
            {orderingEntitiesCount}
          </Text>
        }
        readonly={true}
      />
    </View>
    <View style={[styles.listItem, styles.listItemWithBorder]}>
      <ListItem
        label={
          <Text allowFontScaling maxFontSizeMultiplier={2}>
            {tt('count.qualifyingPoints', 'Qualifying Points')}
          </Text>
        }
        suffix={
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            testID={DownlineProfile.qualifyingPoints}
            variant="button">
            {qualifyingPoints}
          </Text>
        }
        readonly={true}
      />
    </View>
  </ProfileSection>
);

export default withTranslation('screen.coachPerformance.section.miscMetrics')(
  MiscMetrics,
);
